var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3301 14.82C14.4501 14.9 14.5801 14.93 14.7101 14.93C14.9601 14.93 15.2101 14.8 15.3601 14.56C15.5701 14.2 15.4601 13.74 15.1001 13.53L12.0001 11.68C11.6901 11.5 11.3901 10.97 11.3901 10.61V6.51001C11.3901 6.10001 11.0501 5.76001 10.6401 5.76001C10.2301 5.76001 9.89014 6.10001 9.89014 6.51001V10.61C9.89014 11.5 10.4601 12.51 11.2301 12.97L14.3301 14.82Z",
    fill: "#14477D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11C0.25 16.93 5.07 21.75 11 21.75C16.93 21.75 21.75 16.93 21.75 11C21.75 5.07 16.93 0.25 11 0.25C5.07 0.25 0.25 5.07 0.25 11ZM1.75 11C1.75 5.9 5.9 1.75 11 1.75C16.1 1.75 20.25 5.9 20.25 11C20.25 16.1 16.1 20.25 11 20.25C5.9 20.25 1.75 16.1 1.75 11Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.93ed3e7b5baa5b7a12ddf7d703519ba7.svg";
export { ForwardRef as ReactComponent };